// extracted by mini-css-extract-plugin
export default {"svg":"ImageStepFour_svg__muUdE"};